<template>
	<div>
		<div v-if="value">
			<avatar :image="value" :cropped="cropped" size="is-158-high" />
			<button class="button" @click.prevent="clearImage">Remove photo</button>
		</div>

		<div v-else class="dc-dropzone">
			<progress-loader v-if="progress" :value="progress" />
			<dropzone
				v-show="!value && !progress"
				id="image-dropzone"
				ref="myVueDropzone"
				:options="options"
				@vdropzone-error="uploadError"
				@vdropzone-error-multiple="uploadError"
				@vdropzone-success="success"
				@vdropzone-total-upload-progress="upload"
				@vdropzone-queue-complete="complete"
			/>
		</div>
		<div v-if="errorMessage" class="notification is-danger is-light">
			{{ errorMessage }}
		</div>
		<p v-if="showError" class="help is-danger">{{ error }}</p>
		<div class="my-preview vue-dropzone dropzone"></div>
	</div>
</template>

<script>
import Dropzone from "vue2-dropzone";
import Avatar from "../../components/AppAvatar";
import ProgressLoader from "../../components/ProgressLoader";

export default {
	name: "ImageUpload",
	components: { Avatar, Dropzone, ProgressLoader },
	props: {
		value: {
			type: String,
			default: () => ""
		},
		label: {
			type: String,
			default: () => "Image"
		},
		cropped: {
			type: Boolean,
			required: false
		},
		columnWidth: {
			type: Number,
			default: () => 5
		}
	},
	data() {
		return {
			progress: null,
			errorMessage: null,
			showError: false
		};
	},
	computed: {
		options() {
			return {
				url: `${process.env.VUE_APP_SERVICES}/media/image`,
				headers: {
					Authorization: "BEARER " + window.localStorage.getItem("token")
				},
				dictDefaultMessage:
					"<i class='fa fa-cloud-upload'></i> Click or drag file to upload",
				previewsContainer: ".my-preview",
				maxFilesize: 0.5,
				maxFiles: 1
			};
		}
	},
	methods: {
		success(file, response) {
			if (response["url"]) {
				this.$emit("update", response["url"]);
			}
			this.progress = null;
		},
		uploadError(file, message) {
			this.errorMessage = message;
			setTimeout(() => (this.errorMessage = null), 2000);
		},
		upload(totaluploadprogress) {
			this.progress = totaluploadprogress;
		},
		complete() {
			this.progress = null;
		},
		clear() {
			this.errorMessage = null;
		},
		clearImage() {
			this.progress = null;
			this.$emit("update", "");
		}
	}
};
</script>

<style lang="scss" scoped>
.preview-area {
	background-color: white;
}
.dropzone {
	font-family: "proxima-nova", sans-serif;
	border-width: 1px;
}
.button {
	margin-top: 10px;
}
.dc-dropzone {
	min-height: 122px;
	.dropzone {
		border: 1px dashed lightgray;
		border-radius: 4px;
		text-align: center;
		padding: 3rem;

		&:hover,
		&.dz-drag-hover {
			background-color: fade-out(lightgray, 0.9);
			cursor: pointer;
		}
	}
}
.my-preview {
	display: none;
}
</style>
